import {SurveySubmit} from '../components/survey-submit.tsx'
import {BotRating} from '../components/bot-rating.tsx'
import {SubmitLog} from '../components/submit-log.tsx'
import {useChatbotStore} from '../store/chatbotStore'
import {CHATBOT_SOURCES} from '../types'
import i18next from 'i18next'

export const finalFlowsSteps = (isInShootPage: boolean) => [
    {
        id: 'send_log',
        component: <SubmitLog />,
        replace: true,
        trigger: () => {
            useChatbotStore.getState().resetChatHistory()
            return 'oq_message'
        }
    },
    {
        id: 'oq_message',
        message: i18next.t('chatbot:final_steps:starting'),
        trigger: 'oq_options'
    },
    {
        id: 'oq_options',
        options: [
            {
                value: 'yes',
                label: i18next.t('commons:yes'),
                trigger: () => {
                    useChatbotStore.getState().addStepToHistory({
                        id: 'oq_options',
                        source: CHATBOT_SOURCES.USER,
                        text: '[Other question]'
                    })
                    return isInShootPage ? '3' : 'start_generic'
                }
            },
            {
                value: 'no',
                label: i18next.t('commons:no'),
                trigger: 's_start'
            }
        ]
    },
    {
        id: 's_start',
        message: i18next.t('chatbot:final_steps:s_start'),
        trigger: 's_options_rating'
    },
    {
        id: 's_options_rating',
        component: <BotRating />
    },
    {
        id: 's_comment_bad',
        message: i18next.t('chatbot:final_steps:s_comment_bad'),
        trigger: 's_user_comment'
    },
    {
        id: 's_comment',
        message: i18next.t('chatbot:final_steps:s_comment'),
        trigger: 's_user_comment'
    },
    {
        id: 's_user_comment',
        placeholder: i18next.t('chatbot:final_steps:s_user_comment'),
        user: true,
        trigger: 's_submit_survey'
    },
    {
        id: 's_submit_survey',
        component: <SurveySubmit />,
        trigger: 's_end',
        asMessage: true
    },
    {
        id: 's_end',
        message: i18next.t('chatbot:final_steps:s_end'),
        end: true
    }
]
